export default "__VITE_ASSET__90830a96__"